import { render, staticRenderFns } from "./Axis.vue?vue&type=template&id=41226eab&scoped=true&"
import script from "./Axis.vue?vue&type=script&lang=js&"
export * from "./Axis.vue?vue&type=script&lang=js&"
import style0 from "./Axis.vue?vue&type=style&index=0&id=41226eab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41226eab",
  null
  
)

export default component.exports